/**
 * Standalone page — embed: /learn-more/quickbooks-online
 */
import React from "react";
import {
    LearnMoreShell,
    WhatIsForaConnectorSection,
    ForaSignupSection,
    QuickBooksTrademarkSection,
    LearnMoreFooter,
} from "./shared";

export default function LearnMoreQuickBooksOnline() {
    return (
        <LearnMoreShell
            title="QuickBooks Online & Fora Connector"
            subtitle={
                <>
                    Connect <strong>QuickBooks Online</strong> (Intuit&apos;s cloud product) to the{" "}
                    <strong>Fora Mobile Commerce Platform</strong> using Fora Connector.
                </>
            }
        >
            <div className="space-y-6 text-gray-700">
                <WhatIsForaConnectorSection />
                <section className="rounded-lg border border-gray-100 border-l-4 border-l-blue-600 bg-white shadow-sm p-6 sm:p-8">
                    <p className="text-xs font-bold uppercase tracking-wide text-blue-700 mb-1">Platform</p>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Overview</h2>
                    <p className="leading-relaxed mb-4">
                        Use this option when your books live in <strong>QuickBooks Online</strong>. Fora Connector uses
                        Intuit&apos;s OAuth authorization flow to securely connect your QuickBooks Online company to Fora.
                    </p>
                    <ul className="list-disc pl-5 space-y-2 leading-relaxed">
                        <li>
                            <strong>Before connecting:</strong> Sign in to Fora Connector with your company account and
                            confirm the QuickBooks Online company you want to link.
                        </li>
                        <li>
                            <strong>Connect:</strong> Click <strong>Connect to QuickBooks Online</strong>, complete Intuit
                            sign-in/consent, then return to callback to save the link in Fora Connector.
                        </li>
                        <li>
                            <strong>Mapping:</strong> Align field names and structures between QuickBooks Online entities
                            and Fora (for example customers, products, and order-related fields) before running jobs.
                        </li>
                        <li>
                            <strong>Run jobs:</strong> Start customer/product/order jobs from the Run section and monitor
                            completion status to confirm successful transfer.
                        </li>
                        <li>
                            <strong>Logs:</strong> Review results and troubleshoot using the connector&apos;s log views
                            for this platform, including API or data-matching errors.
                        </li>
                        <li>
                            <strong>Disconnect and reconnect:</strong> Use in-app disconnect when needed; this revokes
                            OAuth access to QuickBooks Online. Reconnect later from dashboard with the same connect flow.
                        </li>
                    </ul>
                    <p className="text-sm text-gray-600 leading-relaxed mt-4">
                        Intuit&apos;s product name is <strong>QuickBooks</strong> (capital Q and B).{" "}
                        <strong>QuickBooks Online</strong> is the cloud offering; it is separate from QuickBooks Desktop.
                    </p>
                </section>

                <QuickBooksTrademarkSection />
                <ForaSignupSection />
                <LearnMoreFooter />
            </div>
        </LearnMoreShell>
    );
}
